export enum EmailVerificationType {
  UPDATE = 'update',
  SIGNUP = 'signup'
}

export class EmailVerificationCredentials {
  username: string;
  password: string;
  emailVerificationType: EmailVerificationType;

  constructor(username: string, password: string, emailVerificationType?: EmailVerificationType) {
    this.username = username;
    this.password = password;
    this.emailVerificationType = emailVerificationType;
  }
}
